type SelectorApiValueRange = {
  minimum: number
  maximum?: number
  increment?: number
}

type SelectorApiOptionValue =
  | {
      type: 'stringLiteral'
      stringLiteral: string
    }
  | {
      type: 'numberLiteral'
      numberLiteral?: number
    }
  | {
      type: 'range'
      range?: SelectorApiValueRange
    }

type SelectorApiRemainingOption = {
  key: string
  values: SelectorApiOptionValue[]
}

export type SelectorApiResponse = {
  remainingOptions: SelectorApiRemainingOption[]
}

type GetSelectorApiResponseArgs = {
  productKey: string
  productVersion: number
  merchant: string
  country: string
  selections: Record<string, string>
  authHeader: string
}

const SELECTOR_API_URL_TEMPLATE = 'https://selector-api.products.cimpress.io/v2/products/{ProductKey}/versions/{ProductVersion}:validate'

export const getSelectorApiResponse = async ({
  productKey,
  productVersion,
  merchant,
  country,
  selections,
  authHeader,
}: GetSelectorApiResponseArgs): Promise<SelectorApiResponse> => {
  const endpoint = SELECTOR_API_URL_TEMPLATE.replace('{ProductKey}', encodeURIComponent(productKey)).replace(
    '{ProductVersion}',
    encodeURIComponent(String(productVersion)),
  )

  const response = await fetch(endpoint, {
    method: 'POST',
    headers: {
      Authorization: authHeader,
      'Content-Type': 'application/json',
      priority: 'high',
    },
    body: JSON.stringify({
      selections,
      invalidSelections: {},
      context: {
        Merchant: merchant,
        Country: country,
      },
      includeBuckets: ['option'],
      includeConstraintTypes: ['DISCONTINUED'],
    }),
  })

  if (!response.ok) {
    throw new Error(`Selector API request failed with status ${response.status}`)
  }

  return (await response.json()) as SelectorApiResponse
}
